<template lang="">
    <div class="preloader" v-if="!isLoaded">
        <div class="preloader-main">
            <img src="../assets/img/Preloder.png" alt="">
            <h4>Loading ...</h4>
        </div>
    </div>
</template>
<script>
export default {

    data(){
        return{
            isLoaded: false
        }
    },
    mounted(){
        this.showToglle()
        // document.onreadystatechange = () => {
        //     if(document.readyState == 'complete'){
        //         setTimeout(() => {
        //             this.isLoaded = true
        //         }, 1000)
        //     }
        // }
    },
    methods:{
        showToglle(){
            setTimeout(() => {
                this.isLoaded = true
            }, 1000)
        }
    }
    
}
</script>
<style lang="scss">
    

.preloader {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background-color: white;
    z-index: 999;
}
.preloader-main {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;

    h4{
        font-family: 'Gilroy400';
        font-size: 16px;
        line-height: 180%;
        text-align: center;
        letter-spacing: 0.02em;
        color: #606276;
    }
}


</style>